import React from "react";
import { Form } from "react-bootstrap";

const RadioButtonFormik = ({ formik, inline, field, label, value, onChange }) => (
  <>
    <Form.Check
      inline={inline}
      name={field}
      label={label}
      value={value}
      checked={formik.values[field] === value}
      disabled={formik.isSubmitting}
      onChange={(e) => {
        formik.setFieldValue(field, e.target.value);
        if (typeof onChange === "function") {
          onChange(e);
        }
      }}
      type="radio"
      isInvalid={formik.touched[field] && formik.errors[field]}
    />
    {formik.touched[field] && formik.errors[field] && (
      <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
    )}
  </>
);

export default RadioButtonFormik;
